import { Button } from 'components/duex/Button';
import { ButtonBar } from 'components/duex/ButtonBar';
import { FormTextField } from 'components/duex/FormTextField';
import { Modal } from 'components/duex/Modal';
import { showError } from 'components/error-toast.component';
import { isValidStringOfLength } from 'components/validation/string';
import React, { ReactElement, useState } from 'react';
import { logEvent } from 'utility/Analytics';
import { API } from 'utility/Api';
import { CONSTANTS } from 'utility/Constants';
import { ENDPOINTS } from 'utility/Endpoints';

export const AddAssessmentModal = ({ closeModal }: { closeModal: () => void }): ReactElement => {
    const [assessmentName, setAssessmentName] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    const save = async () => {
        try {
            if (getSaveReadiness()) {
                const started = new Date();
                setIsSaving(true);

                const url = ENDPOINTS.getUrl(CONSTANTS.ASSESSMENT_CREATE_ASSESSMENT);
                const result = await API.post(url, {
                    assessmentName,
                });

                logEvent(`ASSESSMENTS_ADD_ASSESSMENT`, started);

                if (result.data) {
                    setIsSaving(false);
                    closeModal();
                }
            }
        } catch (err) {
            setIsSaving(false);
            showError('There was an error creating your assessment', err);
        }
    };

    const getSaveReadiness = () => {
        return isValidStringOfLength(assessmentName, 3);
    };

    return (
        <Modal
            width="w-400"
            closeModal={closeModal}
            title="Add Assessment"
            closeSafely={() => {
                return !assessmentName;
            }}
        >
            <>
                <fieldset className="flex flex-col gap-16">
                    <FormTextField
                        placeholder="Enter your assessment name here."
                        label="Assessment Name"
                        errorMessage="Please provide an Assessment Name"
                        validator={(currentValue) => {
                            return isValidStringOfLength(currentValue, 3);
                        }}
                        valueChanged={setAssessmentName}
                        required={true}
                        spellCheck={true}
                        maxLength={256}
                    />
                </fieldset>
                <ButtonBar className="mt-24">
                    <Button label="Cancel" onClick={closeModal} buttonType="SECONDARY" disabled={isSaving} />
                    <Button
                        label="Add Assessment"
                        onClick={save}
                        disabled={!getSaveReadiness() || isSaving}
                        loading={isSaving}
                    />
                </ButtonBar>
            </>
        </Modal>
    );
};
